// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kM2K","col":"styles_col__3JnZQ"};